import React from 'react';
import { Paper, Typography, Grid, Box, Divider, Chip } from '@mui/material';

// Enum completo dos desafios (ajuste conforme necessário)
const challengesMap: Record<string, string> = {
    baixa_participacao: 'Baixa participação dos membros',
    falta_recursos: 'Falta de recursos financeiros',
    falta_formacao: 'Falta de formação dos conselheiros',
    falta_articulacao: 'Falta de articulação com outros órgãos',
    jovens: 'Baixa participação de jovens',
    envelhecimento: 'Envelhecimento dos membros',
    falta_mulheres: 'Baixa participação de mulheres',
    falta_representatividade: 'Falta de representatividade de segmentos',
    falta_transparencia: 'Falta de transparência nas decisões',
    falta_comunicacao: 'Falta de comunicação interna',
    falta_planejamento: 'Falta de planejamento das ações',
    falta_avaliacao: 'Falta de avaliação das ações',
    falta_controle_social: 'Falta de controle social',
    falta_incentivo: 'Falta de incentivo à participação',
    falta_parcerias: 'Falta de parcerias institucionais',
    falta_autonomia: 'Falta de autonomia do conselho',
    falta_apoio: 'Falta de apoio do poder público',
    excesso_burocracia: 'Excesso de burocracia',
    rotatividade: 'Alta rotatividade dos membros',
    desmotivacao: 'Desmotivação dos conselheiros',
    outro: 'Outro',
    // Novos enums conforme solicitado:
    er: 'Regularização fundiária',
    sanitaria: 'Sanitária',
    fundiaria: 'Fundiária',
    fiscal: 'Fiscal',
    ambiental: 'Ambiental',
    informacao: 'Informação',
    custo_producao: 'Custo de produção',
    mao_obra: 'Mão de obra',
    mercado: 'Mercado',
    credito_rural: 'Crédito rural',
};

const InfoField: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
    <Box mb={1}>
        <Typography variant="subtitle1" fontWeight={600}>
            {label}
        </Typography>
        <Typography variant="body1">
            {value || 'Não informado'}
        </Typography>
    </Box>
);

interface ChallengeOrder {
    order: number;
    value: string;
}

interface Step4CmdrsViewProps {
    data: {
        selectedChallenges: string[];
        challengesOrder: ChallengeOrder[];
        otherChallenge: string;
    };
}

const Step4CmdrsView: React.FC<Step4CmdrsViewProps> = ({ data }) => (
    <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
        <Typography variant="h5" color="primary" gutterBottom>
            Desafios do CMDRS
        </Typography>
        <Divider sx={{ mb: 3 }} />

        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                    Desafios selecionados
                </Typography>
                {data.selectedChallenges && data.selectedChallenges.length > 0 ? (
                    <Box sx={{ mb: 2 }}>
                        {data.selectedChallenges
                            .filter(challenge => challenge !== 'other')
                            .map((challenge, idx) => (
                                <Chip
                                    key={idx}
                                    label={challengesMap[challenge] ?? challenge ?? 'Não informado'}
                                    sx={{ mr: 1, mb: 1 }}
                                />
                            ))}
                        {data.otherChallenge && (
                            <Chip label={`Outro: ${data.otherChallenge}`} color="secondary" sx={{ mr: 1, mb: 1 }} />
                        )}
                    </Box>
                ) : (
                    <Typography color="text.secondary">Nenhum desafio selecionado.</Typography>
                )}
            </Grid>
            <Grid item xs={12}>
                <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                    Ordem de prioridade dos desafios
                </Typography>
                {data.challengesOrder && data.challengesOrder.length > 0 ? (
                    <Box sx={{ mb: 2 }}>
                        {data.challengesOrder
                            .filter(challenge => challenge.value !== 'outro' && challenge.value !== 'other')
                            .sort((a, b) => a.order - b.order)
                            .map((challenge, idx) => (
                                <Chip
                                    key={idx}
                                    label={`${challenge.order}º - ${challengesMap[challenge.value] ?? challenge.value ?? 'Não informado'}`}
                                    sx={{ mr: 1, mb: 1 }}
                                />
                            ))}
                        {data.otherChallenge && (
                            <Chip label={`Outro: ${data.otherChallenge}`} color="secondary" sx={{ mr: 1, mb: 1 }} />
                        )}
                    </Box>
                ) : (
                    <Typography color="text.secondary">Nenhuma ordem de prioridade definida.</Typography>
                )}
            </Grid>
        </Grid>
    </Paper>
);

export default Step4CmdrsView;